import Swiper from "swiper/bundle";
import { Navigation, Pagination } from "swiper/bundle";
import helpers from "../utils/helpers";



const Business = {
  init: function () {
    Business.trustSlider();
    Business.testiSlider();
    Business.events();
  },


  events() {
    $("#business-form").on("submit", function (e) {
      e.preventDefault();

      const formEl = $(this);

      $(".error", this).removeClass("error");
      if (Business.validate_fields(formEl)) {
        formEl.addClass("loading");

        setTimeout(function () {
          Business.recaptcha();
        }, 500);
      } else {
        formEl.removeClass("loading");
      }
    });
  },


  recaptcha() {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(recaptcha_site_key, {
          action: "submit",
        })
        .then(function (token) {
          Business.sendFormData(token);
        });
    });
  },

  sendFormData(token) {
    const formEl = $("#business-form");
    formEl.find("button").addClass("loading");
    formEl.find(".form__status").addClass("hidden");

    const form_data = {
      email: formEl.find('[name=email]').val(),
      telephone: formEl.find('[name=telephone]').val(),
      company: formEl.find('[name=company]').val(),
      message: formEl.find('[name=message]').val(),
      terms: formEl.find('[name=terms]').prop('checked'),
    };
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_cform",
        form_data: form_data,
        token,
        post_id: formEl.find("[name=post_id]").val(),
        nonce: formEl.find("#offer-form-nonce").val(),
        honey: formEl.find("[name=honey]").val(),
      },
    })
      .done(function (response) {
        if (response.success) {
          formEl.find(".errors-wrap").remove();
          formEl
            .find(".form__status")
            .removeClass("error")
            .text(response.data.message)
            .removeClass("hidden");
          formEl[0].reset();
          formEl.find("input, textarea").blur();
        } else {
          formEl
            .find(".form__status")
            .addClass("error")
            .text(response.data.message)
            .removeClass("hidden");

        }
      })
      .always(function () {
        formEl.removeClass("loading");
        formEl.find("button").removeClass("loading");
      });
  },

  trustSlider() {
    const trustEl = $(".trust");
    if (!trustEl.length) {
      return
    } else {
      let swiper = new Swiper(trustEl.find(".trust__slider")[0],
        {
          slidesPerView: 1,
          spaceBetween: 60,
          autoplay: true,
          loop: true,
          breakpoints: {
            600: {
              slidesPerView: "auto",
            }
          }
        }
      );
    }

  },

  testiSlider() {
    const testiEl = $(".testi");
    if (!testiEl) {
      return
    } else {
      let swiper = new Swiper(testiEl.find(".testi__slider")[0],
        {
          slidesPerView: 1,
          loop: true,
          spaceBetween: 60,
          autoHeight: true,
          navigation: {
            prevEl: testiEl.find(".swiper-button-prev")[0],
            nextEl: testiEl.find(".swiper-button-next")[0],
          },
          breakpoints: {
            600: {
              autoplay: true,
            }
          }

        })
    }
  },

  validate_fields(form) {

    var error_msg = "";
    var errors = [];
    var coords_set = true;

    var inputs = form.find("input.required, select.required, textarea.required").not(".disabled");

    $.each(inputs, function () {
      var input = $(this);

      if (input.val() == "" || input.val() == "0") {
        input.addClass("error");
        input.parent().find(".business-form__label-error").removeClass("hidden");

        let errorText = translations.field_required;
        if (input.hasClass("parcel")) {
          errorText = translations.choose_parcel;
        }

        errors.push(errorText);
        input.closest(".field").find(".field__error").text(errorText).show();
      } else {
        input.removeClass("error");
        input.parent().find(".business-form__label-error").addClass("hidden");
        input.closest(".field").find(".field__error").hide();
      }

      if (input.attr("type") == "tel") {
        const iti = intlTelInputWithUtils.getInstance(input[0]);

        if (iti && !iti.isValidNumber()) {
          input.addClass("error");
          errors.push(translations.valid_phone);

          input
            .closest(".field")
            .find(".field__error")
            .text(translations.valid_phone)
            .show();
        } else {
          input.removeClass("error");
          input.closest(".field").find(".field__error").hide();
        }
      }

      if (input.attr("type") == "email" || input.hasClass("email")) {
        if (!helpers.is_valid_email(input.val())) {
          input.addClass("error");
          errors.push(translations.valid_email);

          input
            .closest(".field")
            .find(".field__error")
            .text(translations.valid_email)
            .show();
        } else {
          input.removeClass("error");
          input.closest(".field").find(".field__error").hide();
        }
      }

      if (input.is(":checkbox")) {
        if (!input.is(":checked")) {
          input.parent().find(".business-form__label-error").removeClass("hidden");
          input.addClass("error");
          errors.push(translations.field_required);
        } else {
          input.removeClass("error");
        }
      }
    });

    if (errors.length) {
      form.addClass("errors");

      return false;
    } else {
      form.removeClass("errors");
      return true;
    }
  }
}

export default Business;
